<script>
import tzMixin from "@/mixins/tzMixin";
import accountMixin from "@/mixins/accountMixin";
import localesMixin from "@/mixins/localesMixin";
import { mapActions } from "vuex";
import Phones from "@/components/Account/Phones/Index";

export default {
  mixins: [tzMixin, accountMixin, localesMixin],
  components: {
    Phones
  },
  props: {
    account: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loader: false,
      status: null
    };
  },

  methods: {
    ...mapActions("snackbar", ["snackbarSuccess", "snackbarError"]),
    ...mapActions("account", [
      "update",
      "sendEmailVerification",
      "verifyEmail",
      "changeStatus"
    ]),

    async submit() {
      this.loader = "update";
      try {
        await this.update(this.account);
        this.$emit("refresh");
        this.snackbarSuccess("Conta atualizada com sucesso!");
      } catch (e) {
        this.snackbarError("Ocorreu um erro ao atualizar a conta!");
      }
      this.loader = false;
    },

    async submitEmailVerification() {
      this.loader = "sendEmailVerification";
      try {
        await this.sendEmailVerification(this.account.id);
        this.$emit("refresh");
        this.snackbarSuccess("Email de verificação enviado com sucesso!");
      } catch (e) {
        this.snackbarError("Ocorreu um erro ao enviar o email de verificação!");
      }
      this.loader = false;
    },

    async submitVerifyEmail() {
      this.loader = "verifyEmail";
      try {
        await this.verifyEmail(this.account.id);
        this.$emit("refresh");
        this.snackbarSuccess("Email verificado com sucesso!");
      } catch (e) {
        this.snackbarError("Ocorreu um erro ao verificar o email!");
      }
      this.loader = false;
    },

    async submitChangeStatus(action, actionTranslated) {
      this.loader = action;
      try {
        await this.changeStatus({ accountID: this.account.id, action });
        this.$emit("refresh");
        this.snackbarSuccess(`Conta ${actionTranslated} com sucesso!`);
      } catch (e) {
        this.snackbarError("Ocorreu um erro ao mudar o status da conta!");
      }
      this.loader = false;
    },

    setStatus() {
      this.status = this.getStatus(this.account.status);
    }
  },

  mounted() {
    this.setStatus();
  },

  watch: {
    account() {
      this.setStatus();
    }
  }
};
</script>

<template>
  <div class="my-3">
    <v-layout wrap>
      <v-flex px-1 lg4 md6 xs12>
        <v-text-field
          name="nome"
          label="nome"
          class="capitalize"
          v-model="account.first_name"
          :error="errors.has('nome')"
          :error-messages="errors.first('nome')"
          v-validate="'required'"
        />
      </v-flex>

      <v-flex px-1 lg4 md6 xs12>
        <v-text-field
          name="sobrenome"
          label="sobrenome"
          v-model="account.last_name"
          :error="errors.has('sobrenome')"
          :error-messages="errors.first('sobrenome')"
          v-validate="'required'"
        />
      </v-flex>

      <v-flex px-1 lg4 md6 xs12>
        <v-text-field
          name="email"
          label="email"
          disabled
          v-model="account.email"
          :error="errors.has('email')"
          :error-messages="errors.first('email')"
          v-validate="'required'"
        />
      </v-flex>

      <v-flex px-1 lg4 md6 xs12>
        <v-text-field
          name="ocupação"
          label="ocupação"
          v-model="account.occupation"
          :error="errors.has('ocupação')"
          :error-messages="errors.first('ocupação')"
        />
      </v-flex>

      <v-flex px-1 lg4 md6 xs12>
        <v-select
          disabled
          :value="account.language"
          :items="locales()"
          label="linguagem"
        ></v-select>
      </v-flex>

      <v-flex px-1 lg4 md6 xs12>
        <v-select
          disabled
          :value="account.time_zone"
          :items="timeZones()"
          label="timezone"
        ></v-select>
      </v-flex>
      <phones :account="account" />
    </v-layout>

    <v-layout v-if="status" row justify-end align-end>
      <v-btn
        v-if="status.order === 4"
        :loading="loader === 'deactivate'"
        :disabled="loader != false"
        @click="submitChangeStatus('deactivate', 'desativada')"
        color="warning"
        rounded
      >
        inativar
        <v-icon class="ml-10" small>remove_circle_outline</v-icon>
      </v-btn>

      <v-btn
        v-if="status.order === 5"
        :loading="loader === 'activate'"
        :disabled="loader != false"
        @click="submitChangeStatus('activate', 'ativada')"
        color="success"
        rounded
      >
        ativar
        <v-icon class="ml-10" small>done_all</v-icon>
      </v-btn>

      <v-btn
        v-if="status.order === 5"
        :loading="loader === 'block'"
        :disabled="loader != false"
        @click="submitChangeStatus('block', 'bloqueada')"
        color="error"
        rounded
      >
        bloquear
        <v-icon class="ml-10" small>block</v-icon>
      </v-btn>

      <v-btn
        v-if="status.order === 6"
        :loading="loader === 'unblock'"
        :disabled="loader != false"
        @click="submitChangeStatus('unblock', 'desbloqueada')"
        color="warning"
        rounded
      >
        desbloquear
        <v-icon class="ml-10" small>remove_circle_outline</v-icon>
      </v-btn>

      <v-btn
        v-if="status.order === 2"
        :loading="loader === 'verifyEmail'"
        :disabled="loader != false"
        @click="submitVerifyEmail"
        color="success"
        rounded
      >
        verificar email
        <v-icon class="ml-10" small>check</v-icon>
      </v-btn>

      <v-btn
        v-if="status.order < 3"
        :loading="loader === 'sendEmailVerification'"
        :disabled="loader != false"
        @click="submitEmailVerification"
        color="warning"
        rounded
      >
        enviar email de verificação
        <v-icon class="ml-10" small>email</v-icon>
      </v-btn>

      <v-btn
        :loading="loader === 'update'"
        :disabled="loader != false"
        color="primary"
        @click="submit"
        rounded
      >
        enviar
        <v-icon class="ml-10" small>send</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_Shared/Users/Account/Attributes.vue